import { useCallback, useState } from "react";

/** Simplified-dashboard redesign (business-owner walkthrough follow-up): everyone lands on
 * the simplified "basics" nav by default; "Advanced" reveals the rest, grouped into
 * collapsible sections (see `NAV_SECTIONS` in `roles/permissions.ts`). Persisted so the
 * choice survives a reload/re-login, same `localStorage` pattern as `lib/storage.ts`. */

const NAV_MODE_KEY = "sl-dashboard-nav-mode";

export type NavMode = "simple" | "advanced";

function readStoredMode(): NavMode {
  return localStorage.getItem(NAV_MODE_KEY) === "advanced" ? "advanced" : "simple";
}

export function useNavMode(): { mode: NavMode; toggle: () => void } {
  const [mode, setMode] = useState<NavMode>(readStoredMode);

  const toggle = useCallback(() => {
    setMode((current) => {
      const next: NavMode = current === "simple" ? "advanced" : "simple";
      localStorage.setItem(NAV_MODE_KEY, next);
      return next;
    });
  }, []);

  return { mode, toggle };
}
